import React, { useMemo } from 'react'
import { ICapabilitiesSummary } from '../../types/capabilitiesSummary'
import { createPackFromDataChartURI } from '../../actions/pack'
import { getAllowedCapability } from '../../services/capabilitiesSummary'
import { Space } from '../../layouts'
import { CreateDataChartForm } from '../../forms'
import { Button, FileUploadZone } from '../../components'
import { checkIfIsLightGroup } from '../../services/groups'

interface IGroupPublishPageSidebar {
  groupId: string
  capabilitiesSummary?: ICapabilitiesSummary
}

export const GroupPublishPageSidebar = ({
  groupId,
  capabilitiesSummary,
}: IGroupPublishPageSidebar) => {
  const {
    showFileZone,
    showDataChartForm,
    showPasteImageFieldForPack,
  } = useMemo(() => getAllowedCapability(capabilitiesSummary), [
    capabilitiesSummary,
  ])
  const isLightGroup = useMemo(() => checkIfIsLightGroup(capabilitiesSummary?.editionTypes || []), [
    capabilitiesSummary?.editionTypes,
  ])
  return (
    <Space pl={3} pr={3}>
      {showFileZone && (
        <Space mb={3}>
          <FileUploadZone
            id="file-input"
            theme="blue"
            groupId={groupId}
            allowPastingImages={showPasteImageFieldForPack}
          />
        </Space>
      )}
      {showDataChartForm && (
        <Space mb={3}>
          <CreateDataChartForm onSubmitAction={createPackFromDataChartURI} />
        </Space>
      )}
      {!isLightGroup && (
        <Button
          variant="contained"
          color="primary"
          to={`/group/${groupId}/pack/create`}
        >
          Create a new pack
        </Button>
      )}
    </Space>
  )
}
